module.exports = __webpack_public_path__ + "static/media/loader.c3c49a2e.svg";